import { ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';
import { EActiveView } from '../../types/view';
import { EHeadingType } from '../../types/headingType';
import { selectView } from '../../selectors/view/view';
import { SubtitleLayout } from '../../components/SubtitleLayout';
import { jsx as _jsx } from "react/jsx-runtime";
export var SubtitleContainer = function SubtitleContainer(_ref) {
  var useSelector = _ref.useSelector;
  var _useSelector = useSelector(selectView),
    active = _useSelector.active,
    data = _useSelector.data;
  switch (active) {
    case EActiveView.AuthenticationRegistration:
    case EActiveView.PhoneAuth:
      switch (data === null || data === void 0 ? void 0 : data.headingType) {
        case EHeadingType.Notifications:
          return /*#__PURE__*/_jsx(SubtitleLayout, {
            children: /*#__PURE__*/_jsx(ArticleParagraph1, {
              children: "\u0421\u043E\u043E\u0431\u0449\u0438\u043C \u043E\u0431 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u0446\u0435\u043D\u044B \u0438\xA0\u043D\u043E\u0432\u044B\u0445\xA0\u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043F\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u043F\u043E\u0438\u0441\u043A\u0443"
            })
          });
        default:
          return null;
      }
    default:
      return null;
  }
};